import React, {MouseEventHandler, useContext} from "react";
import {GenericComponentModel, SelectElementModelBE, SelectElementModelFE} from "../../../api/types/generic";
import {useTranslation} from "react-i18next";
import SearchFilters from "../../../common/components/SearchFilters";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";

const ExceptionListAncillaryExceptionFilters = ({
                                                    handleClickSearch,
                                                    handleClickResetSearch,
                                                    testFilters,
                                                    setTestFilters
                                                }: {
    handleClickSearch: MouseEventHandler<HTMLButtonElement>
    handleClickResetSearch: MouseEventHandler<HTMLButtonElement>
    testFilters: any
    setTestFilters: any
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    // Use Context
    const {globalData: {user},} = useContext(GlobalContext);

    const legalEntityOptions: SelectElementModelFE[] = user.legalEntities?.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:legalEntities.'.concat(el.name))
        })
    );

    const dealerOptions: SelectElementModelFE[] = user.dealers.map(
        (el: SelectElementModelBE) => ({
            code: el.name,
            label: t('translation:dealers.'.concat(el.name))
        })
    );

    const filtersOutOfCollapse: GenericComponentModel[] = [
        {
            name: "exceptionListName",
            value: testFilters.exceptionListName as string,
            label: `${t("pricing:exceptionList.table.headers.exceptionList")}`,
            handleChange: (value: string) => setTestFilters({
                ...testFilters,
                exceptionListName: value
            }),
            options: [],
            type: "TextField"
        },
        {
            name: "exceptionName",
            value: testFilters.exceptionName as string,
            label: `${t("pricing:exceptionList.table.headers.ancillaryExceptions")}`,
            handleChange: (value: string) => setTestFilters({
                ...testFilters,
                exceptionName: value
            }),
            options: [],
            type: "TextField"
        },
        {
            name: "legalEntities",
            value: testFilters.legalEntities as SelectElementModelFE,
            label: `${t(
                "pricing:rate.form.labels.mainDefinitionLabels.legalEntity"
            )}`,
            handleChange: (value: SelectElementModelFE) =>
                setTestFilters({...testFilters, legalEntities: value}),
            options: legalEntityOptions || [],
            type: "AutocompleteM",
            hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
        },
        {
            name: "dealers",
            value: testFilters.dealers as SelectElementModelFE,
            label: `${t("pricing:rate.form.labels.mainDefinitionLabels.dealer")}`,
            handleChange: (value: SelectElementModelFE) =>
                setTestFilters({...testFilters, dealers: value}),
            options: dealerOptions || [],
            type: "AutocompleteM",
            hide: user.legalEntities.length === 1 && user.dealers.length === 1 ? true : false
        },
    ];
    const filtersInCollapse: GenericComponentModel[] = [];


    return (
        // <CardContainer>
        <SearchFilters
            filtersOutOfCollapse={filtersOutOfCollapse}
            filtersInCollapse={filtersInCollapse}
            handleClickSearch={handleClickSearch}
            handleClickResetSearch={handleClickResetSearch}
        />
        // </CardContainer>
    );
};

export default ExceptionListAncillaryExceptionFilters;